/* House of Neve - uitklapmenu (mega menu):
   - start onder de aankondigingsbalk
   - overal even hoog: de hoogte van de banner op de homepage */
(function () {
  var FALLBACK_HEIGHT = 560; /* gebruikt tot de homepage een keer bezocht is */
  var STORE_KEY = 'honMegaHeight';

  function isHomepage() {
    var path = window.location.pathname.replace(/[/]+$/, '');
    return path === '' || /^[/][a-z]{2}(-[a-z]{2})?$/i.test(path);
  }

  function readStored() {
    try {
      var value = parseInt(window.localStorage.getItem(STORE_KEY), 10);
      if (value > 200 && value < 1400) return value;
    } catch (e) {}
    return null;
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(STORE_KEY, String(value));
    } catch (e) {}
  }

  function honSetMega() {
    if (window.innerWidth < 990) return;

    var wrapper = document.querySelector('.header-wrapper');
    var panels = document.querySelectorAll('.mega-menu__content');
    if (!wrapper || !panels.length) return;

    var wrapperBottom = wrapper.getBoundingClientRect().bottom;

    /* De aankondigingsbalk blijft zichtbaar: paneel begint daaronder */
    var startBottom = wrapperBottom;
    var groupSections = document.querySelectorAll('.shopify-section-group-header-group');
    for (var g = 0; g < groupSections.length; g++) {
      var rect = groupSections[g].getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > startBottom) {
        startBottom = rect.bottom;
      }
    }
    var top = Math.round(startBottom - wrapperBottom);

    /* Op de homepage meten we de banner en onthouden we die hoogte */
    var height = readStored() || FALLBACK_HEIGHT;
    if (isHomepage()) {
      var first =
        document.querySelector('#MainContent > .shopify-section') ||
        document.querySelector('#MainContent .shopify-section');
      if (first) {
        var measured = Math.round(first.getBoundingClientRect().bottom - startBottom);
        if (measured > 200) {
          height = measured;
          writeStored(measured);
        }
      }
    }

    for (var i = 0; i < panels.length; i++) {
      panels[i].style.setProperty('--hon-mega-top', top + 'px');
      panels[i].style.setProperty('--hon-mega-height', height + 'px');
    }
  }

  function honBindSummaries() {
    var summaries = document.querySelectorAll('.mega-menu > summary');
    for (var j = 0; j < summaries.length; j++) {
      if (summaries[j].dataset.honMegaBound) continue;
      summaries[j].dataset.honMegaBound = 'true';
      summaries[j].addEventListener('mouseenter', honSetMega);
      summaries[j].addEventListener('click', function () {
        setTimeout(honSetMega, 0);
      });
    }
  }

  function honInit() {
    honSetMega();
    honBindSummaries();
  }

  honInit();
  document.addEventListener('DOMContentLoaded', honInit);
  window.addEventListener('load', honInit);
  window.addEventListener('resize', honSetMega);
  document.addEventListener('shopify:section:load', honInit);
})();